export default "__VITE_ASSET__qm4nI5lR__"